module.exports = __webpack_public_path__ + "img/banner_desktop.b9cf6535.png";